import React from 'react';
import ReactDOM from 'react-dom/client';

/** State Management */
import { StoreProvider } from 'easy-peasy';
import store from './state/store';
import App from './App';

import './index.css';
import "./assets/styles/fonts.css";
import "./assets/styles/styles.css"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StoreProvider store={store}>
    <App />
  </StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
